<div
  class="relative w-full h-full flex flex-col justify-center cursor-pointer p-2 bg-white rounded-md min-h-[250px]"
  [ngClass]="{
    'outline-2 outline-dashed outline-blue-500': isDragging() && !control()?.disabled,
    'pointer-event-none cursor-not-allowed': control()?.disabled,
  }"
  (click)="triggerFileDialog()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  @if (label()) {
    <mat-label class="text-sm font-semibold mb-1 pointer-events-none" [class.opacity-50]="control()?.disabled">
      {{ label() }}
    </mat-label>
  }

  <div
    class="w-full flex-1 flex items-center justify-center border-b border-gray-100"
    [class.opacity-50]="control()?.disabled"
  >
    <div class="pointer-events-none">
      <ng-content></ng-content>
    </div>

    <input
      #fileInput
      type="file"
      class="hidden"
      [accept]=""
      (change)="onFilesSelected($event)"
      multiple
      [disabled]="control()?.disabled"
    />
  </div>
</div>
